Reflect.defineProperty(CDATASection.prototype, "jsonData", {
    get() {
        try {
            return JSON.parse(this.nodeValue.trim());
        }
        catch(e) { return null }
    }
});